import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import CloseIcon from "@mui/icons-material/Close"
import { ButtonContainer, CancelButton, ConfirmButton, ModalHeader } from "./Atom"
import { useSelector } from "react-redux"
import { modalContainerStyles } from "../Atom"
import { makeFullName } from "../../../../helper/utils"
import { useDispatch } from "react-redux"
import { setGroupInfo } from "../../../redux/slices/groupProfileSlice"

type Props = {}

const GroupInfoConfirmation = (props: any) => {
    const dispatch = useDispatch()

    const { open, setOpen, type, groupInfo, selectedGa, setSelectedGa, setGaValue, selectedAdvisor, setSelectedAdvisor, setAdvisorValue, selectedCsm, setSelectedCsm, setCsmValue, assignPrimaryContact, assignAdvisor, assignCsm, groupInfoHandler } = props

    const currentGaName = groupInfo?.primary_contact?.primary_contact
    const currentAdvisorName = groupInfo?.advisor_list?.[0]?.name
    const currentCsmName = groupInfo?.csm_list?.[0]?.name
    const groupName = groupInfo?.group_name
    const groupsK = groupInfo?.group_sk
    const selectedGaName = makeFullName(selectedGa?.first_name, selectedGa?.last_name);
    const gaId = selectedGa?.uid;
    const selectedAdvisorName = makeFullName(selectedAdvisor?.first_name, selectedAdvisor?.last_name);
    const advisorId = selectedAdvisor?.uid;
    const selectedCsmName = makeFullName(selectedCsm?.first_name, selectedCsm?.last_name);
    const csmId = selectedCsm?.uid;

    const handleClose = () => {
        // type == "new" ? handleRemoveNewTab() : type == "edit" ? setCurrentActiveEditBucketName(-1) : type == "del" ? "" : "";
        setSelectedGa({});
        setGaValue("")
        setSelectedAdvisor({});
        setAdvisorValue("")
        setSelectedCsm({})
        setCsmValue("")
        setOpen(false);
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="groupInfo-modal-title"
            aria-describedby="groupInfo-modal-description"
        >
            <Box sx={modalContainerStyles}>

                <ModalHeader>
                    <CloseIcon
                        sx={{ marginRight: "10px", marginTop: "10px", cursor: "pointer" }}
                        onClick={() => {
                            handleClose()
                        }}
                    />
                </ModalHeader>

                <Typography
                    id="modal-modal-title"
                    fontSize={"18px"}
                    fontWeight={500}
                    sx={{ padding: "10px 10px 30px 10px", textAlign: "center", borderBottom: "1px solid grey" }}
                >
                    {
                        type == "pc" ?
                            <>
                                Are you sure to change the Primary contact from <b>{`"${currentGaName}"`}</b>  to <b>{`"${selectedGaName}"`}</b> for group  <b>{`"${groupName}"`}</b>?
                            </>
                            :
                            type == "advisor" ?
                                <>
                                    Are you sure to change the Advisor from <b>{`"${currentAdvisorName}"`}</b>  to <b>{`"${selectedAdvisorName}"`}</b> for group  <b>{`"${groupName}"`}</b>?
                                </>
                                :
                                type == "csm" ?
                                    <>
                                        Are you sure to change the CSM from <b>{`"${currentCsmName}"`}</b>  to <b>{`"${selectedCsmName}"`}</b> for group  <b>{`"${groupName}"`}</b>?
                                    </>
                                    :
                                    <></>}
                </Typography>

                <br />
                {/* <Divider /> */}

                <ButtonContainer
                >
                    <CancelButton
                        onClick={() => handleClose()}
                    >
                        <Typography color={"#4A79E7"}>Cancel</Typography>
                    </CancelButton>
                    <ConfirmButton
                        onClick={async () => {
                            type == "pc" ?
                                assignPrimaryContact(groupsK, gaId)

                                :
                                type == "advisor" ?
                                    assignAdvisor(groupsK, advisorId)

                                    :
                                    type == "csm" ?
                                        assignCsm(groupsK, csmId)
                                        :
                                        "";
                            type == "pc" ?
                                dispatch(setGroupInfo({ ...groupInfo, primary_contact: { primary_contact: selectedGaName } }))

                                :
                                type == "advisor" ?
                                    dispatch(setGroupInfo({ ...groupInfo, advisor_list: [{ name: selectedAdvisorName }] }))

                                    :
                                    type == "csm" ?
                                        dispatch(setGroupInfo({ ...groupInfo, csm_list: [{ name: selectedCsmName }] }))
                                        :
                                        "";
                            type == "pc" ? await groupInfoHandler(groupsK) : "";
                            handleClose();
                        }}
                    >
                        <Typography color={"#ffffff"}>Yes</Typography>
                    </ConfirmButton>
                </ButtonContainer>
            </Box>
        </Modal>
    )
}

export default GroupInfoConfirmation